/**
 * Klasa bazowa (Base Class) dla wszystkich typów powiadomień Server-Sent Events (SSE).
 * Definiuje wspólny interfejs, ale konkretna logika biznesowa zależy od instancji klasy potomnej
 * (np. `VetClinicInfoDataSyncNotification`, `BookSseNotification`).
 *
 * W kodzie aplikacji typ powiadomienia jest rozpoznawany poprzez mechanizm `instanceof`,
 * co pozwala na bezpieczne rzutowanie i obsługę specyficznych pól w klasach dziedziczących.
 */
export class SseNotification {

  /**
   * Identyfikator typu powiadomienia.
   */
  public type: string;

  constructor() {
  }
}
